var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5H4V20.5C4 21.0304 4.21071 21.5391 4.58579 21.9142C4.96086 22.2893 5.46957 22.5 6 22.5H11V12.5H5ZM18 12.5H13V22.5H18C18.5304 22.5 19.0391 22.2893 19.4142 21.9142C19.7893 21.5391 20 21.0304 20 20.5V12.5H18ZM18.791 7.5C18.9364 7.01351 19.0069 6.50771 19 6C19 4.07 17.43 2.5 15.5 2.5C13.878 2.5 12.795 3.982 12.096 5.585C11.407 4.07 10.269 2.5 8.5 2.5C6.57 2.5 5 4.07 5 6C5 6.596 5.079 7.089 5.209 7.5H2V11.5H11V9.5H13V11.5H22V7.5H18.791ZM7 6C7 5.173 7.673 4.5 8.5 4.5C9.388 4.5 10.214 6.025 10.698 7.5H8C7.626 7.5 7 7.5 7 6ZM15.5 4.5C16.327 4.5 17 5.173 17 6C17 7.5 16.374 7.5 16 7.5H13.523C14.033 5.924 14.774 4.5 15.5 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.b402b35f1774a3bfe171d901311df727.svg";
export { ForwardRef as ReactComponent };